import {FormControl, InputLabel, MenuItem, Select} from '@mui/material';
import {SeedQuestionStatus} from '@cp/model';
import {env} from '../../config/env';

export interface DropdownSeedQuestionStatusProps {
  status?: SeedQuestionStatus;
  /** change of status, undefined/null means any status */
  onChange: (status?: SeedQuestionStatus) => void;
  /** Whether to show "All Statuses" option (for optional status) */
  allowAll?: boolean;
  /** Disable the dropdown */
  disabled?: boolean;
  /** Full width control */
  fullWidth?: boolean;
  /** Label for the dropdown */
  label?: string;
}

export default function DropdownSeedQuestionStatus({
  status,
  onChange,
  allowAll = false,
  disabled = false,
  fullWidth = true,
  label = 'Status',
}: DropdownSeedQuestionStatusProps) {
  const statuses = Object.values(SeedQuestionStatus);
  const displayValue = status || '';

  return (
    <FormControl fullWidth={fullWidth} data-testid="dropdown-seed-question-status">
      <InputLabel>{label}</InputLabel>
      <Select
        value={displayValue}
        onChange={(e) => onChange(e.target.value ? (e.target.value as SeedQuestionStatus) : undefined)}
        label={label}
        disabled={disabled}
      >
        {allowAll && (
          <MenuItem value="">
            <em>All Statuses</em>
          </MenuItem>
        )}
        {statuses.map((statusValue) => (
          <MenuItem key={statusValue} value={statusValue}>
            {env.seedQuestion.status[statusValue]?.label ?? env.seedQuestion.unknownStatus.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
